module.exports = __webpack_public_path__ + "static/media/cartas black.19c6c6bc.svg";